import type { ReactNode } from "react";

type StaticPageProps = {
  title: string;
  children?: ReactNode;
};

export function StaticPage({ title, children }: StaticPageProps) {
  return (
    <section className="content-page">
      <h1>{title}</h1>
      <div className="panel">
        {children ?? <p>Раздел будет наполнен после переноса основного MVP на Supabase.</p>}
      </div>
    </section>
  );
}
